export default __webpack_public_path__ + "static/media/nature_dark_male.45416356.png";